<template>
  <div v-if="items">
    <p align="center" style="text-align:center"><b><span style="font-size:12.0pt"><span style="font-family:Arial">{{ title }}</span></span></b></p>

    <p>&nbsp;</p>

    <table class="MsoTableGrid" style="border-collapse:collapse; border:solid windowtext 1.0pt">
      <tbody>
      <tr v-if="type === 'admin'" style="height:24.05pt">
        <td rowspan="2" style="width:35.2pt; border:solid windowtext 1.0pt" width="35">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:24.05pt"><b><span style="font-size:11.0pt"><span style="font-family:Arial">№№</span></span></b></span></p>
        </td>
        <td rowspan="2" style="width:150.2pt; border:solid windowtext 1.0pt; border-left:none" width="150">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:24.05pt"><b><span style="font-size:11.0pt"><span style="font-family:Arial">Регион</span></span></b></span></p>
        </td>
        <td colspan="4" style="width:251.55pt; border:solid windowtext 1.0pt; border-left:none" width="252">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:24.05pt"><b><span style="font-size:11.0pt"><span style="font-family:Arial">Число компаний с определенным статусом</span></span></b></span></p>
        </td>
        <td rowspan="2" style="width:72.8pt; border:solid windowtext 1.0pt; border-left:none" width="73">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:24.05pt"><b><span style="font-size:11.0pt"><span style="font-family:Arial">Итого по региону</span></span></b></span></p>
        </td>
      </tr>
      <tr v-else style="height:24.05pt">
        <td rowspan="2" style="width:35.2pt; border:solid windowtext 1.0pt" width="35">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:24.05pt"><b><span style="font-size:11.0pt"><span style="font-family:Arial">№№</span></span></b></span></p>
        </td>
        <td rowspan="2" style="width:150.2pt; border:solid windowtext 1.0pt; border-left:none" width="150">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:24.05pt"><b><span style="font-size:11.0pt"><span style="font-family:Arial">Менеджер</span></span></b></span></p>
        </td>
        <td colspan="4" style="width:251.55pt; border:solid windowtext 1.0pt; border-left:none" width="252">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:24.05pt"><b><span style="font-size:11.0pt"><span style="font-family:Arial">Число компаний с определенным статусом</span></span></b></span></p>
        </td>
        <td rowspan="2" style="width:72.8pt; border:solid windowtext 1.0pt; border-left:none" width="73">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:24.05pt"><b><span style="font-size:11.0pt"><span style="font-family:Arial">Итого по менеджеру</span></span></b></span></p>
        </td>
      </tr>
      <tr style="height:32.75pt">
        <td style="width:81.05pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="81">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:32.75pt"><span style="font-size:11.0pt"><span style="font-family:Arial">Верификация</span></span></span></p>
        </td>
        <td style="width:95.3pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="95">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:32.75pt"><span style="font-size:11.0pt"><span style="font-family:Arial">Участники инф. мероприятия</span></span></span></p>
        </td>
        <td style="width:75.2pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="75">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:32.75pt"><span style="font-size:11.0pt"><span style="font-family:Arial">Кандидат</span></span></span></p>
        </td>
        <td style="width:75.2pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="75">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:32.75pt"><span style="font-size:11.0pt"><span style="font-family:Arial">Архив</span></span></span></p>
        </td>
      </tr>
      <tr v-for="(item, key) in items" :key="key" style="height:20.85pt">
        <td style="width:35.2pt; border:solid windowtext 1.0pt; border-top:none" width="35">
          <p style="padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><span style="font-size:11.0pt"><span style="font-family:Arial">{{ key + 1 }}</span></span></span></p>
        </td>
        <td style="width:150.2pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="150">
          <p style="padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><span style="font-size:11.0pt"><span style="font-family:Arial">{{ type === 'admin' ? item.region : item.user }}</span></span></span></p>
        </td>
        <td style="width:81.05pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="81">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><span style="font-size:11.0pt"><span style="font-family:Arial">{{ item.verify }}</span></span></span></p>
        </td>
        <td style="width:95.3pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="95">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><span style="font-size:11.0pt"><span style="font-family:Arial">{{ item.event }}</span></span></span></p>
        </td>
        <td style="width:75.2pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="75">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><span style="font-size:11.0pt"><span style="font-family:Arial">{{ item.candidate }}</span></span></span></p>
        </td>
        <td style="width:75.2pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="75">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><span style="font-size:11.0pt"><span style="font-family:Arial">{{ item.archive }}</span></span></span></p>
        </td>
        <td style="width:72.8pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="73">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><b><span style="font-size:11.0pt"><span style="font-family:Arial">{{ item.all }}</span></span></b></span></p>
        </td>
      </tr>
      </tbody>
    </table>
    <p>&nbsp;</p>
    <p v-if="type === 'manager'"><span style="font-size:12.0pt"><span style="font-family:Arial">Регион:  {{ region }}</span></span></p>
    <p><span style="font-size:12.0pt"><span style="font-family:Arial">Дата отчета:  {{ date }}</span></span></p>
  </div>
</template>

<script>
    import * as AppStorage from '../../storage/appstorage';
    export default {
        name: "VerifyListPrint",
        props: ['items', 'type', 'region'],
        data() {
            return {
                user: JSON.parse(AppStorage.get('user')),
                title: 'Отчет по регионам о статусе верификации компаний',
                date: null
            }
        },
        mounted() {
            this.title =  this.type === 'admin'
                ? 'Отчет по регионам о статусе верификации компаний'
                : 'Отчет по менеджерам о статусе верификации компаний';

            let today = new Date(),
                dd = today.getDate(),
                mm = today.getMonth() + 1;
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            this.date = dd + '.' + mm + '.' + today.getFullYear();
        }
    }
</script>

<style scoped>

</style>
